//Aqui
//Alterar para em projeto/producao e/ou Homolocao
// versao.js basutlaxios.js baseultapi.js api.js e ambiente.js
// ultima versao para : producao 
const versao = "Versão Front End: 1.0.0.15 Conection"
export default versao